import { useMutation } from "react-query-legacy";

import { cancelPackageDelivery, redeliverPackage } from "api/logistics/shipment";

const useCancelPackageDelivery = (shipmentID: string) => {
  return useMutation((packageID: string) => cancelPackageDelivery(packageID, shipmentID));
};

const useRedeliverPackage = (shipmentID: string) => {
  return useMutation((packageID: string) => redeliverPackage(packageID, shipmentID));
};

export { useCancelPackageDelivery, useRedeliverPackage };
